// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.funBtn[data-v-5f3aac8e]{\r\n  font-size: 20px;\n}\n.btnNav[data-v-5f3aac8e]{\r\n  height: 70px;\r\n  width: 100%;\r\n  line-height: 58px;  /*  扣除pad/margin.. (用google devlTool看的) */\n}\r\n", ""]);
// Exports
module.exports = exports;
